var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.357 4.158v13.014c0 1.55-1.264 2.828-2.799 2.828H4.445c-1.538 0-2.801-1.277-2.801-2.828V4.158H.648c-.864 0-.864-1.326 0-1.326H5.76V1.56C5.76.73 6.403 0 7.243 0h3.517c.837 0 1.483.733 1.483 1.56v1.272h5.11c.863 0 .863 1.326 0 1.326h-.997zM7.07 2.832h3.858V1.56c0-.097-.058-.234-.169-.234H7.243c-.114 0-.172.137-.172.234v1.272zm4.787 12.138c0 .87-1.312.87-1.312 0V7.75c0-.87 1.312-.87 1.312 0v7.22zm-4.405 0c0 .87-1.311.87-1.311 0V7.75c0-.87 1.311-.873 1.311 0v7.22zm7.592-10.812H2.958v13.014c0 .827.665 1.502 1.487 1.502h9.113c.819 0 1.487-.675 1.487-1.502V4.158z",
    fill: "#737B7D"
  })));
}

export default SvgDeleteIcon;